import { useDispatch } from "react-redux";
import { Fragment, useEffect } from "react";
import { useParams } from "react-router-dom";

import { fetchBlog } from "../redux/features/blog/blogSlice";
import BackToHome from "../components/BackToHome";
import BlogDetail from "../components/BlogDetail";
import RelatedBlog from "../components/RelatedBlog";


const Blog = () => {
    const dispatch = useDispatch();
    const { blogID } = useParams();

    useEffect(() => { dispatch(fetchBlog(blogID)); }, [blogID, dispatch]);

    return (
        <Fragment>
            <BackToHome />
            <section className="post-page-container">
                <BlogDetail />
                <RelatedBlog />
            </section>
        </Fragment>
    );
};

export default Blog;